import { FloatingServiceMenu } from '@components/Page'
import { Container, Icon, OldText } from '@gassan-ui'
import { useBodyScrollLock } from '@lib/hooks/useBodyScrollLock'
import { Item } from '@lib/kontent'
import { BrandPage } from '@lib/kontent/models/BrandPage'
import { StoreService } from '@lib/kontent/models/StoreService'
import { useTranslation } from 'next-i18next'
import React, { FC, useRef, useState } from 'react'
import { FilterAction, FilterState } from '../reducer'
import FilterBar from './FilterBar'
import FilterOverlay from './FilterOverlay'
import * as S from './elements'

type FiltersProps = {
  dispatch: React.Dispatch<FilterAction>
  brands?: Item<BrandPage>[]
  services?: Item<StoreService>[]
  filters: FilterState
  totalStores: number
}

const Filters: FC<FiltersProps> = ({ dispatch, brands, services, filters, totalStores }) => {
  const { t } = useTranslation('stores')
  const [isOverlayActive, setIsOverlayActive] = useState(false)
  const ref = useRef()

  useBodyScrollLock(ref, isOverlayActive)
  return (
    <>
      <Container
        alignItems="center"
        display="flex"
        flexWrap="wrap"
        pt={{ _: '1rem', medium: '1.5rem', large: '2rem' }}
        mb={{ _: '2rem', medium: '3rem', large: '4rem' }}
        borderTop={1}
        borderTopStyle="solid"
        borderTopColor="shades.200"
      >
        <OldText color="shades.500" mb="1rem" mr="2.25rem">
          {totalStores} {t(totalStores === 1 ? 'store' : 'stores')}
        </OldText>
        <FilterBar dispatch={dispatch} brands={brands} services={services} filters={filters} />
        <S.FilterButton onClick={() => setIsOverlayActive(true)}>
          Filters<Icon icon="settings"></Icon>
        </S.FilterButton>
      </Container>
      {isOverlayActive && (
        <FilterOverlay
          ref={ref}
          dispatch={dispatch}
          brands={brands}
          services={services}
          filters={filters}
          onRequestClose={() => setIsOverlayActive(false)}
        />
      )}
      {!isOverlayActive && <FloatingServiceMenu />}
    </>
  )
}

export default Filters
